"use client";

import type { ReactNode } from "react";
import { createContext, useContext } from "react";

import type { TenantBranding, TenantId } from "./tenantBranding";
import { DEFAULT_TENANT_ID, getTenantBranding } from "./tenantBranding";

const TenantContext = createContext<TenantId>(DEFAULT_TENANT_ID);

/**
 * Brands a page for a tenant (Miragon fork, see tenantBranding.ts). The marker switches the CSS placeholders on :root,
 * so that dialogs and menus rendered outside this tree follow as well; components read the tenant's logo, links and
 * default brand colors with useTenantBranding. Without a provider, everything shows Miragon.
 */
export function TenantBrandingProvider({ tenant, children }: { tenant: TenantId; children: ReactNode }) {
  return (
    <TenantContext.Provider value={tenant}>
      <span data-tenant={tenant} hidden />
      {children}
    </TenantContext.Provider>
  );
}

export function useTenantBranding(): TenantBranding {
  return getTenantBranding(useContext(TenantContext));
}
